import { Breadcrumbs, IBreadcrumbsProps } from "@blueprintjs/core";
import * as React from "react";

interface IAppBreadcrumbProps extends Pick<IBreadcrumbsProps, "items"> {}

export const AppBreadcrumb: React.FunctionComponent<IAppBreadcrumbProps> = (props) => {
  return <Breadcrumbs items={props.items}/>;
};
